module.exports = __webpack_public_path__ + "img/ico-error-gray.bcbab9d2.svg";